import { sumBy } from 'lodash';

export default {
  getExpenseDocument: (state) => (id) => state.expenseDocuments.find((d) => d.id === id),
  getExpenseDocuments: (state) => state.expenseDocuments,
  getParentDocuments: (state) => state.expenseDocuments.map((d) => {
    const result = { ...d };
    result.description = `${d.supplier} - ${d.documentNumber} (${sumBy(d.lineItems, (t) => Math.round(t.quantity * t.unitCost + parseFloat(t.vat))).toLocaleString()})`;
    return result;
  }),
};
